document.addEventListener('DOMContentLoaded', function () {

    // security – only works on edit-account
    if (!document.body.classList.contains('woocommerce-account')) return;
    if (!window.location.pathname.includes('edit-account')) return;

    function toggleEditAccountSections() {
        const details  = document.getElementById('edit-account-details');
        const password = document.getElementById('edit-account-password');

        if (!details || !password) return;

        const isPassword = window.location.hash === '#password';

        details.style.display  = isPassword ? 'none' : 'block';
        password.style.display = isPassword ? 'block' : 'none';
    }

    toggleEditAccountSections();
    window.addEventListener('hashchange', toggleEditAccountSections);

});